import React from "react";
import { Helmet } from "react-helmet";
import { FormattedMessage, useIntl } from "react-intl";
import { useOutletContext } from "react-router";
import { css } from "@emotion/react";
import { PageWrapper } from "components/Containers";
import { Grid } from "components/Containers";
import { ApplicantListLayout, ApplicantSelectedCount } from "components/Missions/Applicants";
import { APPLICANT_LIST_COLUMNS, BANNER_TYPE, MISSION_ROLE_STATES } from "constants/index";
import { Spinner } from "components/Loader";
import { Banner } from "components/Banner";
import { RoleAtsReport } from "components/Missions/Roles";
import { margins } from "style";
import PageTitle from "components/PageTitle";

/**
 * Mission Role Applications
 */
const MissionRoleApplications = () => {
  const { selectedRole, loading } = useOutletContext();
  const intl = useIntl();

  if (loading) {
    return <Spinner />;
  }

  return (
    <PageWrapper>
      <Helmet>
        <title>{intl.formatMessage({ id: "Meta.Missions.Role.Applications.Title" })}</title>
      </Helmet>
      <Grid>
        {selectedRole?.state === MISSION_ROLE_STATES.closed && (
          <Grid.col start={1} end={13} style={{ marginTop: margins.normal }}>
            <Banner isClosable={false} type={BANNER_TYPE.warning}>
              <FormattedMessage id="Missions.Roles.Applications.ClosedRole.BannerText" />
            </Banner>
          </Grid.col>
        )}
        <RoleAtsReport slug={selectedRole?.slug} />
        <PageTitle
          subtitle={<FormattedMessage id="Missions.Mission.Role.Applications.Pipeline" />}
          css={styles.pipeline}
        />
        <Grid.col start={1} end={13}>
          <ApplicantListLayout
            defaultSelected={{
              missionId: selectedRole?.mission?.id,
              missionRoleIds: [selectedRole?.id],
              organizationId: selectedRole?.mission?.organization?.id,
            }}
            showAdvancedOptions={true}
            hideOrganizationFilter={true}
            hideMissionFilter={true}
            hideFilters={true}
            hideTabs={true}
            hideMemberFilter={false}
            hideSorts={false}
            hideKeywordSearch={false}
            hideAdvancedFilters={false}
            columns={[
              APPLICANT_LIST_COLUMNS.memberWithDisciplines,
              APPLICANT_LIST_COLUMNS.status,
              APPLICANT_LIST_COLUMNS.checklistPercentage,
              APPLICANT_LIST_COLUMNS.location,
              APPLICANT_LIST_COLUMNS.missionStats,
              APPLICANT_LIST_COLUMNS.rate,
              APPLICANT_LIST_COLUMNS.activity,
              APPLICANT_LIST_COLUMNS.viewButton,
            ]}
            variablesProp={{
              includeFlaggedCommentsCount: true,
            }}
            enableCountQueries={true}
            paginationRightContainer={ApplicantSelectedCount}
          />
        </Grid.col>
      </Grid>
    </PageWrapper>
  );
};

const styles = {
  pipeline: css`
    margin-top: -4rem;
    margin-bottom: -2rem;
  `,
};

export default MissionRoleApplications;
